import { motion } from "framer-motion";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { MaskLines } from "../site/Reveal";

export default function AdvisoryHero() {
  return (
    <section
      data-testid="advisory-hero"
      className="relative min-h-[92vh] flex items-end bg-background text-foreground grain overflow-hidden"
    >
      <div className="beam-glow pointer-events-none absolute inset-0 opacity-70" />
      <div className="pointer-events-none absolute -top-24 right-[-10%] h-[480px] w-[480px] rounded-full bg-[var(--blush-deep)]/45 blur-3xl" />

      <div className="container-luxe relative z-10 pb-24 pt-44 lg:pb-32">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="overline flex items-center gap-3 text-[var(--gold-soft)]"
        >
          <span className="h-px w-8 bg-[var(--gold)]" />
          Hospitality Advisory · By Beam Concierge
        </motion.p>

        <h1 className="mt-8 serif text-[clamp(2.6rem,6.4vw,5.4rem)] leading-[1.02] tracking-tight">
          <MaskLines
            lines={[
              <>Five-star service</>,
              <>
                begins <span className="italic text-[var(--gold-soft)]">behind</span>
              </>,
              <>the scenes.</>,
            ]}
          />
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-muted-foreground"
        >
          Executive operational advisory for boutique hotels, luxury resorts, retreats,
          and high-end short-term rentals. We rebuild the systems behind your guest
          experience — so your time becomes your greatest asset again.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.65, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#audit"
            data-testid="advisory-hero-cta-audit"
            className="group inline-flex items-center justify-center gap-3 bg-secondary px-8 py-4 text-sm text-secondary-foreground hover:bg-[var(--gold)] transition-colors duration-400"
          >
            Take the FREE Time-Wealth Audit
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="#transformation"
            data-testid="advisory-hero-cta-transformation"
            className="group inline-flex items-center justify-center gap-3 border border-border px-8 py-4 text-sm text-foreground hover:border-[var(--gold)] hover:text-gold transition-colors duration-400"
          >
            Explore the 90-Day Transformation
            <ArrowDownRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
